import { useState } from 'react';
import { Modal } from '@/components/common/AppModal';
import { Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

type GiftCodeModalProps = {
  show: boolean;
  onHide: () => void;
};

const GiftCodeModal = ({ show, onHide }: GiftCodeModalProps) => {
  const [giftCode, setGiftCode] = useState<string>('');
  const trimmedGiftCode = giftCode.trim();

  const handleApplyGiftCode = () => {
    setGiftCode(trimmedGiftCode);
    toast.error('کد هدیه نامعتبر هست');
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-1">استفاده از کدهدیه</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="giftCodeInput">
          <Form.Label>کدهدیه دارید؟</Form.Label>
          <Form.Control
            type="text"
            value={giftCode}
            onChange={e => setGiftCode(e.target.value)}
            placeholder="کد هدیه را وارد کنید"
            style={{ direction: 'ltr', textAlign: 'left' }}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleApplyGiftCode}
          disabled={!trimmedGiftCode}
        >
          استفاده
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GiftCodeModal;
